/**
 * A constant string representing the class names used for MouseFlow masking and listening.
 * Used to hide sensitive information from MouseFlow recordings.
 */
export const MOUSE_FLOW_CLASS_NAMES = 'mf-masked mf-listen';